import { render } from "./StandingsCard.vue?vue&type=template&id=1dff6a64"
import script from "./StandingsCard.vue?vue&type=script&lang=js"
export * from "./StandingsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__